import { COLOR_BACKGROUND_LEVEL_0_LIGHT, PAGE_MARGIN_S } from '@audi/audi-ui-design-tokens';
import {
	SYS_BREAKPOINT_2_XL,
	SYS_BREAKPOINT_LG,
	SYS_BREAKPOINT_MD,
	SYS_BREAKPOINT_SM,
	SYS_BREAKPOINT_XL,
	SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT,
	SYS_PAGE_MARGIN_2_XL,
	SYS_PAGE_MARGIN_LG,
	SYS_PAGE_MARGIN_MD,
	SYS_PAGE_MARGIN_SM,
	SYS_PAGE_MARGIN_XL,
} from '@oneaudi/unified-web-common';
import styled from 'styled-components';

import { breakPoints, customBreakPoint } from '~/styles/break-points';
import { DefaultBarHeightBigSummary } from '~/styles/default-bar';

export const SummaryHeaderPriceBarStyle = styled.div<{ $isScrolled: boolean }>`
	position: sticky;
	display: flex;
	top: 0;
	bottom: calc(100% - ${DefaultBarHeightBigSummary}px);
	background-color: ${COLOR_BACKGROUND_LEVEL_0_LIGHT};
	z-index: 9;
	flex-direction: row;
	justify-content: end;
	align-items: center;
	gap: ${PAGE_MARGIN_S}px;
	border-bottom: ${(props) => (props.$isScrolled ? `1px solid ${SYS_COLOR_SURFACE_NEUTRAL_500_LIGHT}}` : 'none')};

	.bar-container {
		width: 100%;
		display: flex;
		justify-content: center;

		padding: 0 ${SYS_PAGE_MARGIN_SM};

		@media screen and (min-width: ${SYS_BREAKPOINT_SM}) {
			padding-left: ${SYS_PAGE_MARGIN_SM};
			padding-right: ${SYS_PAGE_MARGIN_SM};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_MD}) {
			padding-left: ${SYS_PAGE_MARGIN_MD};
			padding-right: ${SYS_PAGE_MARGIN_MD};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_LG}) {
			padding-left: ${SYS_PAGE_MARGIN_LG};
			padding-right: ${SYS_PAGE_MARGIN_LG};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_XL}) {
			padding-left: ${SYS_PAGE_MARGIN_XL};
			padding-right: ${SYS_PAGE_MARGIN_XL};
		}

		@media screen and (min-width: ${SYS_BREAKPOINT_2_XL}) {
			padding-left: ${SYS_PAGE_MARGIN_2_XL};
			padding-right: ${SYS_PAGE_MARGIN_2_XL};
		}

		.default-bar {
			padding-top: ${(props) => (props.$isScrolled ? '12px' : 'auto')};
			max-width: 1248px;
			width: 100%;
			display: flex;
			/* gap: 8px; */

			.icon-headline-container {
				display: flex;
				align-self: flex-start;

				margin-bottom: ${(props) => (props.$isScrolled ? '0' : '24px')};
				${breakPoints({
					'1024': 'margin-bottom: 0; height: 100%; align-items: center;',
				})}
			}
		}
	}

	.headline-container {
		transition: all 0.3s ease;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		${breakPoints({
			'1024': 'width: unset;',
		})}
	}

	.headline__main {
		word-break: keep-all;
		transition: all 0.3s ease;
		display: flex;
		flex-direction: row;
		width: 100%;
	}

	.headline__sub {
		transition: all 0.3s ease;
		display: flex;
		flex-direction: row;
		width: 100%;
	}

	.headline-back-button {
		top: 20px;
		left: 0;
		transition: all 0.3s ease;

		.back__button {
			height: 42px;
			width: 42px;
		}
	}

	.calc-sum {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: flex-start;
		width: 100%;

		${breakPoints({
			'1024': `
				justify-content: flex-end;
			    margin-left: auto;
				width: unset !important;
			`,
		})}
		${breakPoints({
			'768': `
				flex-direction: row;
				align-items: end;
			`,
		})}
	}

	.info-block {
		display: flex;
		flex-direction: column;
		${breakPoints({
			'1024': 'flex-direction: row;',
		})}

		&  .calculation-info-item {
			word-break: keep-all;
		}
	}

	.main-cta-button {
		min-width: max-content; // To overwrite the min-width of the component
		width: 100%;
		${breakPoints({
			'768': 'width: auto;',
		})}
	}
`;

export const CalcBackStyles = styled.div<{ $isScrolled: boolean }>`
	display: flex;
	flex-direction: ${(props) => (props.$isScrolled ? 'row' : 'column')};
	margin-bottom: 24px;
	align-items: ${(props) => (props.$isScrolled ? 'center' : 'flex-start')};

	${breakPoints({
		'1024': 'flex-direction: column;',
		'768': 'margin-bottom: 0;',
	})}
`;

export const ButtonGroupStyles = styled.div<{ $isScrolled: boolean }>`
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
	align-self: center;

	@media screen and (min-width: 768px) {
		flex-direction: ${(props) => (props?.$isScrolled ? 'row' : 'column')};
		width: auto;
	}
	${customBreakPoint(1024, 'flex-direction: row; margin-top: auto;')}

	button {
		width: 100%;
		${customBreakPoint(1024, 'width: max-content')}
	}
`;

export const CarlineStyles = styled.div<{ $isScrolled: boolean }>`
	display: flex;
	align-self: flex-start;
	margin-bottom: ${(props) => (props.$isScrolled ? '0' : '24px')};
	${breakPoints({
		'1024': 'margin-bottom: 0; height: 100%; align-items: end;',
	})}
`;
